import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import * as actionTypes from '../constants/actionTypes'
import * as actionCreators from './actions'
import { initialState } from './initialState'

export const ASSESSMENT_EC = actionTypes.GLOBAL_STATE

const assessmentECSlice = createSlice({
  name: ASSESSMENT_EC,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(actionCreators.assessmentECClear, state => {
      state[actionTypes.ASSESSMENT_EC] = initialState().ASSESSMENT_EC
    })

    builder
      .addCase(actionCreators.assessmentEC.pending, state => {
        state[actionTypes.ASSESSMENT_EC].loading = true
      })
      .addCase(actionCreators.assessmentEC.rejected, (state, action) => {
        state[actionTypes.ASSESSMENT_EC].loading = false
        state[actionTypes.ASSESSMENT_EC].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentEC.fulfilled, (state, action) => {
        state[actionTypes.ASSESSMENT_EC].loading = false
        state[actionTypes.ASSESSMENT_EC].error = null
        state[actionTypes.ASSESSMENT_EC].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentECAll.pending, state => {
        state[actionTypes.ASSESSMENT_EC_ALL].loading = true
      })
      .addCase(actionCreators.assessmentECAll.rejected, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_ALL].loading = false
        state[actionTypes.ASSESSMENT_EC_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentECAll.fulfilled, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_ALL].loading = false
        state[actionTypes.ASSESSMENT_EC_ALL].error = null
        state[actionTypes.ASSESSMENT_EC_ALL].data = action.payload
      })
    builder
      .addCase(actionCreators.assessmentECCreate.pending, state => {
        state[actionTypes.ASSESSMENT_EC_CREATE].loading = true
      })
      .addCase(actionCreators.assessmentECCreate.rejected, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_CREATE].loading = false
        state[actionTypes.ASSESSMENT_EC_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentECCreate.fulfilled, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_CREATE].loading = false
        state[actionTypes.ASSESSMENT_EC_CREATE].error = null
        state[actionTypes.ASSESSMENT_EC_CREATE].data = action.payload
      })
    builder
      .addCase(actionCreators.assessmentECOutcomeReport.pending, state => {
        state[actionTypes.ASSESSMENT_EC_OUTCOME_REPORT].loading = true
      })
      .addCase(actionCreators.assessmentECOutcomeReport.rejected, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_OUTCOME_REPORT].loading = false
        state[actionTypes.ASSESSMENT_EC_OUTCOME_REPORT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentECOutcomeReport.fulfilled, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_OUTCOME_REPORT].loading = false
        state[actionTypes.ASSESSMENT_EC_OUTCOME_REPORT].error = null
        state[actionTypes.ASSESSMENT_EC_OUTCOME_REPORT].data = action.payload
      })
    builder
      .addCase(actionCreators.assessmentECPaper.pending, state => {
        state[actionTypes.ASSESSMENT_EC_PAPER].loading = true
      })
      .addCase(actionCreators.assessmentECPaper.rejected, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_PAPER].loading = false
        state[actionTypes.ASSESSMENT_EC_PAPER].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentECPaper.fulfilled, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_PAPER].loading = false
        state[actionTypes.ASSESSMENT_EC_PAPER].error = null
        state[actionTypes.ASSESSMENT_EC_PAPER].data = action.payload
      })
    builder
      .addCase(actionCreators.assessmentECChangeStatus.pending, state => {
        state[actionTypes.ASSESSMENT_EC_STATUS].loading = true
      })
      .addCase(actionCreators.assessmentECChangeStatus.rejected, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_STATUS].loading = false
        state[actionTypes.ASSESSMENT_EC_STATUS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentECChangeStatus.fulfilled, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_STATUS].loading = false
        state[actionTypes.ASSESSMENT_EC_STATUS].error = null
        state[actionTypes.ASSESSMENT_EC_STATUS].data = action.payload
      })
    builder
      .addCase(actionCreators.assessmentECUpdate.pending, state => {
        state[actionTypes.ASSESSMENT_EC_UPDATE].loading = true
      })
      .addCase(actionCreators.assessmentECUpdate.rejected, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_UPDATE].loading = false
        state[actionTypes.ASSESSMENT_EC_UPDATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentECUpdate.fulfilled, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_UPDATE].loading = false
        state[actionTypes.ASSESSMENT_EC_UPDATE].error = null
        state[actionTypes.ASSESSMENT_EC_UPDATE].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentECReport.pending, state => {
        state[actionTypes.ASSESSMENT_EC_REPORT].loading = true
      })
      .addCase(actionCreators.assessmentECReport.rejected, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_REPORT].loading = false
        state[actionTypes.ASSESSMENT_EC_REPORT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentECReport.fulfilled, (state, action) => {
        state[actionTypes.ASSESSMENT_EC_REPORT].loading = false
        state[actionTypes.ASSESSMENT_EC_REPORT].error = null
        state[actionTypes.ASSESSMENT_EC_REPORT].data = action.payload
      })
  },
})

export const { reducer: assessmentECReducer } = assessmentECSlice
